export enum EventSources {
  DEFAULT = 'shipshape-app',
  REDUX = 'shipshape-app.internal',
}
